// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * GET and PUT /users/me (P20EE-208): the person's own data, and nothing else — no credential, CPF, birth date or
 * account status. The e-mail and the phone are shown, never sent back: they are the login identifier and the channel
 * of the login code. `.strict()`, so a field that starts leaking fails here instead of reaching the screen (P20EE-210).
 */
export const ownProfileSchema = z
    .object({
        id: z.number().int().positive(),
        name: z.string(),
        email: z.string().nullable(),
        phone: z.string().nullable(),
        permiteContato: z.boolean(),
    })
    .strict()
export type OwnProfile = z.infer<typeof ownProfileSchema>
